import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface CallerIdentityProps {
    readonly name: string | null;
    readonly number: string;
    readonly size?: 'sm' | 'default' | 'lg' | 'xl';
    readonly className?: string;
}

function initialsFromFullName(name: string): string {
    const parts = name.trim().split(/\s+/);
    const first = parts[0]?.charAt(0) ?? '';
    const last = parts.length > 1 ? (parts[parts.length - 1]?.charAt(0) ?? '') : '';
    return `${first}${last}`.toUpperCase() || '?';
}

/** Caller/contact identity — avatar + name (falls back to the raw number). */
export function CallerIdentity({ name, number, size = 'default', className }: CallerIdentityProps) {
    return (
        <div className={cn('flex items-center gap-3', className)}>
            <Avatar size={size}>
                <AvatarFallback>{name ? initialsFromFullName(name) : '#'}</AvatarFallback>
            </Avatar>
            <div className="min-w-0 flex-1">
                <p className="truncate text-[calc(0.875rem*var(--voice-scale,1))] font-semibold tracking-tight text-text-primary">
                    {name ?? number}
                </p>
                {name && (
                    <p className="truncate text-[calc(0.75rem*var(--voice-scale,1))] text-text-tertiary">
                        {number}
                    </p>
                )}
            </div>
        </div>
    );
}
